import Vue from 'vue'

export const namespaced = true

export const state = {
  orders: [],
  order: {},
  reservationId: null,
}

export const mutations = {
  SET_ORDERS(state, orders) {
    state.orders = orders
  },
  SET_ORDER(state, order) {
    state.order = order
  },
  SET_RESERVATION_ID(state, reservationId) {
    state.reservationId = reservationId
  },
  UPDATE_STATES(state, reservation) {
    // console.log('Vuex Update reservation, currently items:', state.order?.reservations?.length)
    let indexToReplace = state.order?.reservations?.findIndex(obj => obj.id == reservation.id)
    if (indexToReplace != -1) {
      // console.log(` - update reservation ${reservation.id} state from ${state.order.reservations[indexToReplace].customer_contract_state} to ${reservation.customer_contract_state}`)
      // state.order.reservations.splice(indexToReplace, 1)
      state.order.reservations[indexToReplace].customer_contract_state = reservation.customer_contract_state
      state.order.reservations[indexToReplace].guests.forEach(guest => {
        guest.otpservice_state = reservation.guests.find(new_guest => new_guest.id == guest.id).otpservice_state
      })
      state.order.reservations.push({})
      state.order.reservations.splice(-1, 1)
    } else {
      state.order.reservations.push(reservation)
    }
  },
  // After updates use this mutation to refresh the single item into the cache
  REFRESH_ORDER_IN_ORDERS(state, order=state.order) {
    // console.log('Vuex Refresh orders, currently items:', state.orders.length)
    let indexToReplace = state.orders.findIndex(obj => obj.id == order.id)
    if (indexToReplace != -1) {
      // console.log(' - replace old with newest, id', order.id)
      state.orders.splice(indexToReplace, 1)
    }
    state.orders.push(order)
    // console.log('  - replaced! New items:', state.orders.length)
  },
  UPDATE_RESERVATION_IMAGE(state, {reservation_id, guest_state, info_image, guest_id}){
    let photo_to_add = true
    let indexToReplace = state.order?.reservations?.findIndex(obj => obj.id == reservation_id)
    if (indexToReplace != -1) {
      if (state.order.reservations[indexToReplace].reservation_documents &&
          state.order.reservations[indexToReplace].reservation_documents[guest_id]) {
        state.order.reservations[indexToReplace].reservation_documents[guest_id].map((photo) => {
          if (photo.name == info_image.name) {
            photo_to_add = false
            photo.id = info_image.id
            photo.url = info_image.url
          }
        })
      }else{
        state.order.reservations[indexToReplace].reservation_documents[guest_id] = []
      }

      if(guest_state){
        let indexGuest = state.order.reservations[indexToReplace]?.guests?.findIndex(obj => obj.id == guest_id)
        if(guest_state.recognition_state != 'refused'){
          state.order.reservations[indexToReplace].guests[indexGuest].recognition_state = guest_state.recognition_state
          state.order.reservations[indexToReplace].guests[indexGuest].recognition_reason = null

        }

      }
      if (photo_to_add) {
        state.order.reservations[indexToReplace].reservation_documents[guest_id].push(info_image)
      }
      state.order.reservations[indexToReplace].reservation_documents[guest_id] = state.order.reservations[indexToReplace].reservation_documents[guest_id].sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    }

  },
  SET_INVOICE_ACCOUNT_ID(state, invoice_account_id) {
    state.order.invoice_account_id = invoice_account_id
  },
}

export const actions = {
  updateGuest({ commit, dispatch, rootState }, { order, guest }) {
    return new Promise((resolve, reject) => {
      const url = rootState.application.urls.guest
        .replace(':order_id', order.id)
        .replace(':reservation_id', guest.reservation_id)
        .replace(':id', guest.id)

      Vue.http.put(url, {
        guest: guest,
      }).then(response => {
        guest = response.body

        const reservationIndex = order.reservations.findIndex(r => r.id === guest.reservation_id)
        const guestIndex = order.reservations[reservationIndex].guests.findIndex(g => g.id === guest.id)
        order.reservations[reservationIndex].guests[guestIndex] = guest
        commit('SET_ORDER', order)

        resolve(guest)
      }, error => {
        reject(error)
      })
    })
  },
  createGuest({ commit, dispatch, rootState }, { order, guest }) {
    return new Promise((resolve, reject) => {
      const tempGuestId = guest.id
      const url = rootState.application.urls.create_guest
        .replace(':order_id', order.id)
        .replace(':reservation_id', guest.reservation_id)

      Vue.http.post(url, {
        guest: guest,
      }).then(response => {
        guest = response.body

        const reservationIndex = order.reservations.findIndex(r => r.id === guest.reservation_id)
        const guestIndex = order.reservations[reservationIndex].guests.findIndex(g => g.id === tempGuestId)
        order.reservations[reservationIndex].guests[guestIndex] = guest
        commit('SET_ORDER', order)

        resolve(guest)
      }, error => {
        reject(error)
      })
    })
  },
  fetchOrders({ commit, dispatch, rootState }, status_param = 'OPEN') {
    return new Promise((resolve, reject) => {
      commit('invoice_account/CLEAR_INVOICE_ACCOUNT', null, { root: true })
      dispatch('layout/set_loading', true, { root: true })

      let url = `${rootState.application.urls.orders_index}?status=${status_param}`

      Vue.http.get(url, null, { responseType: 'json' })
        .then(response => {
          let orders = response.data
          commit('SET_ORDERS', orders)
          dispatch('layout/set_loading', false, { root: true })
          resolve(orders)
        }).catch(error => {
          dispatch('layout/set_loading', false, { root: true })
          console.log('fetchOrders There was an error:', error.response ? error.response : error)
          reject(error)
        })
    })
  },
  fetchOrder({ commit, dispatch, getters, rootState }, {id, fresh=false}) {
    return new Promise((resolve, reject) => {
      let uuid = /[a-z]*[0-9]*\-/.exec(id) ? id : null
      let order

      if (!fresh) {
        order = uuid ? getters.getOrderByUuid(uuid) : null
      }

      if (order) {
        // Rimpiazziamo order con quello dell'id ricercato
        commit('SET_ORDER', order)
        resolve(order)
      } else {
        dispatch('layout/set_loading', true, { root: true })
        let url = rootState.application.urls.order_show.replace(':id', id)

        return Vue.http.get(url, null, { responseType: 'json' })
          .then(response => {
            order = response.data
            commit('SET_ORDER', order)
            commit('REFRESH_ORDER_IN_ORDERS', order)
            dispatch('layout/set_loading', false, { root: true })
            resolve(order)
          })
          .catch(error => {
            console.log('fetchOrder There was an error:', error.response ? error.response : error)
            dispatch('layout/set_loading', false, { root: true })
            reject(error)
          })
      }
    })
  },
  fetchOrderPublic({ commit, dispatch, getters, rootState }, uuid) {
    return new Promise((resolve, reject) => {
      // console.log(`fetchOrder uuid ${uuid} rootState ${rootState.application.urls.order_show_public}`)
      let order = getters.getOrderByUuid(uuid)
      if (order) {
        // Rimpiazziamo order con quello dell'uuid ricercato
        commit('SET_ORDER', order)
        resolve(order)
      } else {
        dispatch('layout/set_loading', true, { root: true })
        let url = rootState.application.urls.order_show_public.replace(':uuid', uuid)
        return Vue.http.get(url, null, {
          responseType: 'json'
        }).then(response => {
          order = response.data
          commit('SET_ORDER', order)
          commit('invoice_account/CLEAR_INVOICE_ACCOUNT', null, { root: true })
          dispatch('layout/set_loading', false, { root: true })
          resolve(order)
        })
          .catch(error => {
            console.log('fetchOrderPublic There was an error:', error.response ? error.response : error)
            dispatch('layout/set_loading', false, { root: true })
            reject(error)
          })
      }
    })
  },
  /*fetchOrderToUpdateReservation({ commit, dispatch, getters, rootState }, id) {
    return new Promise((resolve, reject) => {
      // console.log(`order/fetchOrderToUpdateReservationState id ${id}`)
      let url = rootState.application.urls.order_show.replace(':id', id)
      return Vue.http.get(url, null, {
        responseType: 'json',
      }).then(response => {
        const order = response.data
        const reservation = order.reservations[0]
        commit('UPDATE_STATES', reservation)
        resolve(reservation)
      }).catch(error => {
        console.log('order/fetchOrderToUpdateReservationState There was an error:', error.response ? error.response : error)
        reject(error)
      })
    })
  },*/
  /*assignOrder({ commit, dispatch, getters, rootState }, uuid) {
    return new Promise((resolve, reject) => {
      console.log(`order/assignOrder id ${uuid} `)
      dispatch('layout/set_loading', true, { root: true })

      let url = rootState.application.urls.order_redeem.replace(':uuid', uuid)
      return Vue.http.put(url, null, {
        responseType: 'json',
        }).then(response => {
          let order = response.data
          commit('SET_ORDER', order)
          dispatch('layout/set_loading', false, { root: true })
          resolve(order)
        })
        .catch(error => {
          console.log('assignOrder There was an error:', error.response ? error.response : error)
          dispatch('layout/set_loading', false, { root: true })
          reject(error)
        })
    })
  },*/
  fetchProducts({ commit, dispatch, rootState }, { orderId, reservationId, language }) {
    return new Promise((resolve, reject) => {
      dispatch('layout/set_loading', true, { root: true })
      const url = rootState.application.urls.products
        .replace(':order_id', orderId)
        .replace(':reservation_id', reservationId)

      Vue.http.get(url, null, { headers: { 'Accept-Language': language }, responseType: 'json' })
        .then(response => {
          dispatch('layout/set_loading', false, { root: true })
          resolve(response.data)
        }).catch(error => {
          dispatch('layout/set_loading', false, { root: true })
          console.log('fetchProducts There was an error:', error.response ? error.response : error)
          reject(error)
        })
    })
  },
  conclusionUpdateOrder({ commit, dispatch, rootState }, { order_id, reservation_id, params }) {
    dispatch('layout/submitting_request', true, { root: true })
    return new Promise((resolve, reject) => {
      let order
      const url = rootState.application.urls.order_conclusion.replace(':id', order_id)
      params.reservation_id = reservation_id

      Vue.http.put(url, params)
        .then(response => {
          order = response.body
          commit('SET_ORDER', order)
          commit('REFRESH_ORDER_IN_ORDERS', order)
          resolve(response)
        }, error => {
          reject(error)
        })
        .finally(() => (dispatch('layout/submitting_request', false, { root: true })))
    })
  },
  updateOrderInOrders({ commit }, order) {
    return new Promise((resolve, reject) => {
      // console.log(`order/updateOrderInOrders ${order.uuid} `)
      commit('SET_ORDER', order)
      commit('REFRESH_ORDER_IN_ORDERS', order)
    })
  },
  setReservationId({ commit }, reservationId) {
    commit('SET_RESERVATION_ID', reservationId)
  },

  reservationDetail({ commit, dispatch, rootState}, {reservationId}) {
    return new Promise((resolve, reject) => {
      let url = rootState.application.urls.reservation_details.replace(':id', reservationId)
      dispatch('layout/set_loading', true, { root: true })
      Vue.http.get(url)
        .then(response => {
          const reservation = response.body
          dispatch('layout/set_loading', false, { root: true })
          resolve(reservation)
        })
        .catch(error => {
          console.log('fetchOrderPublic There was an error:', error.response ? error.response : error)
          dispatch('layout/set_loading', false, { root: true })
          reject(error)
        })
    })
  },

  updateRecognitionPhoto ({ commit, dispatch, rootState }, {orderId, reservationId, attributes}) {
    return new Promise((resolve, reject) => {

      let url = rootState.application.urls.order_update_recognition_photo.replace(':order_id', orderId)
      url = url.replace(':id', reservationId)
      dispatch('layout/submitting_request', true, { root: true })
      Vue.http.put(url, attributes)
        .then(response => {
          const recipient = response.data
          resolve(recipient)
        }, error => {
          reject(error)
        })
    })
  }
}

export const getters = {
  getOrderById: state => id => {
    return state.orders.find(order => order.id == id)
  },
  getOrderByUuid: state => uuid => {
    return state.orders.find(order => order.uuid === uuid)
  },
}
